import ColcadeLayout from '@frontend/utils/ColcadeLayout';
import FilterContainer from '@components/048-FilterContainer/FilterContainer';
import gsap from 'gsap';

export default class TeaserListC {
	private readonly element: HTMLElement;

	protected filterContainer?: FilterContainer;

	private colcade!: ColcadeLayout;

	public constructor(element: HTMLElement) {
		this.element = element;
		this.init();
	}

	public init(): void {
		this.initResultContainer();
		this.initColcade();
	}

	public initColcade(): void {
		const colcade = this.element.querySelector('.l-colcade');

		if (colcade) {
			this.colcade = new ColcadeLayout(colcade);
		}
	}

	public initResultContainer(): void {
		const filterContainer: HTMLElement | null = this.element.querySelector('.m-teaser-list-c__filter-container');
		const filterPanel: HTMLElement | null = this.element.querySelector('.m-teaser-list-c__filter-panel');

		if (filterContainer && filterPanel) {
			this.filterContainer = new FilterContainer(filterContainer, {
				panel: filterPanel,
				onBeforeEmptyContainer: (): void => {
					this.destroyColcade();
				},
				onAfterRenderResult: (): void => {
					this.initColcade();
					gsap.from('.m-teaser-list-c__teaser', {
						opacity: 0,
						duration: 0.3,
						clearProps: true
					});
				},
				onAfterPaginate: (): void => {
					this.destroyColcade();
					this.initColcade();
				}
			});
		}
	}

	public destroyColcade(): void {
		if (this.colcade) {
			this.colcade.destroy();
			delete this.colcade;
		}
	}

	public destroy(): void {
		this.destroyColcade();
	}
}
